import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a73bded"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-overlay"
}
const _hoisted_2 = {
  key: 1,
  open: "",
  class: "popup popup--small js-popup is-opened"
}
const _hoisted_3 = { class: "popup__title" }
const _hoisted_4 = { class: "popup__content" }
const _hoisted_5 = { class: "auth-steps js-auth-steps js-auth-step-1 is-active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinnerSmall = _resolveComponent("LoadingSpinnerSmall")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showSignUpReportLoadingModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showSignUpReportLoadingModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", null, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
            ], true)
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
              _createVNode(_component_LoadingSpinnerSmall, { class: "report-loader" })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}